(function () {
  'use strict';

  var form = document.getElementById('ll-wl-form');
  if (!form) return;

  // Exclude this form from Shopify's form-persister script. That script runs
  // at DOMContentLoaded and targets customer forms via the selector:
  // form[action*='/contact']:not([data-nocaptcha='true']) input[name='form_type'][value='customer']
  // Setting the attribute here (defer scripts run before DOMContentLoaded)
  // prevents the persister from wrapping form.submit() on this element.
  form.setAttribute('data-nocaptcha', 'true');

  // Disable native browser validation; we handle it ourselves.
  form.noValidate = true;

  // querySelector('[type="email"]') is more resilient than a class selector
  // in case the class name is ever renamed; the name-attribute fallback covers
  // any edge case where type is stripped by a browser normalisation pass.
  var emailInput   = form.querySelector('[type="email"]') || form.querySelector('[name="contact[email]"]');
  var errorEl      = form.querySelector('.ll-drop-waitlist__error');
  var submitBtn    = form.querySelector('.ll-drop-waitlist__btn');

  var card      = form.closest('.ll-drop-waitlist');
  var formArea  = card && card.querySelector('.ll-wl-form-area');
  var confirmEl = card && card.querySelector('.ll-wl-confirm');

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
  }

  function showError(type) {
    if (!errorEl) return;
    errorEl.textContent = errorEl.dataset[type + 'Error'] || '';
    errorEl.style.display = '';
    if (type === 'email' && emailInput) emailInput.setAttribute('aria-invalid', 'true');
  }

  function hideError() {
    if (!errorEl) return;
    errorEl.style.display = 'none';
    if (emailInput) emailInput.removeAttribute('aria-invalid');
  }

  function showConfirm() {
    if (!formArea || !confirmEl) return;
    formArea.style.opacity = '0';
    formArea.style.pointerEvents = 'none';
    setTimeout(function () {
      formArea.style.display = 'none';
      // display:grid must be set before transitioning opacity
      confirmEl.classList.add('is-visible');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          confirmEl.style.opacity = '1';
        });
      });
    }, 200);
  }

  if (emailInput) emailInput.addEventListener('input', hideError);

  // Re-enable on bfcache restore. The browser preserves the full DOM state
  // on back-forward navigation, including a button disabled mid-flight.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && submitBtn) submitBtn.disabled = false;
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!validEmail(emailInput ? emailInput.value : '')) {
      showError('email');
      return;
    }

    if (submitBtn) submitBtn.disabled = true;
    hideError();

    // Strip the fragment (#ll-wl-form) Shopify appends to the form action so
    // the fetch URL is clean: https://louislounis.de/contact
    var action = form.action.split('#')[0];

    // POST as FormData. Shopify processes the subscription and responds with
    // a redirect to ?customer_posted=true; fetch follows it transparently and
    // the Promise resolves with a 200. Any resolved response means the request
    // reached Shopify — show the confirmation. Only a network-level failure
    // (DNS, dropped connection) causes the Promise to reject and shows the
    // error message. The button is re-enabled in .finally() on every path.
    // FormData includes the hidden contact[accepts_marketing]=1 field, so
    // Shopify registers a marketing opt-in and sends the double-opt-in mail.
    fetch(action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin'
    })
    .then(function () { showConfirm(); })
    .catch(function () { showError('submit'); })
    .finally(function () { if (submitBtn) submitBtn.disabled = false; });
  });
}());
